export enum StorageParams {
    FIRST_WEB_VISIT_TS = 'first_web_visit_ts',
    FIRST_WEB_VISIT_RND = 'first_web_visit_rnd'
}
